<template>
  <div class="container mx-auto">
    <div class="flex justify-center">
      <div class="fixed inset-0 flex items-center justify-center bg-sp-secondary bg-opacity-70">
        <div class="max-w-2xl p-8 mx-4 bg-sp-secondary text-sp-primary rounded-lg shadow-xl">
          <div class="flex items-center justify-center">
            <div class="m-6 h-14 w-14 animate-spin rounded-full border-4 border-solid border-current border-r-transparent 
              align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]" role="status">
              <span class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
